export default __webpack_public_path__ + "static/media/video-2.3f552370.mp4";